import React, { memo } from 'react';
import * as S from './styles';

interface VersionLabelProps {
  className?: string; 
}

const VersionLabel: React.FC<VersionLabelProps> = memo(({ className }) => {
    const appVersion = process.env.REACT_APP_VERSION; 
    
    if (!appVersion) {
        return null;
    }

    return (
        <S.VersionWrapper className={className}>
            <S.VersionLabelText>
                V. {appVersion}
            </S.VersionLabelText>
        </S.VersionWrapper>
    );
});

export default VersionLabel;